var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9007 3.12592C17.3314 2.41427 16.4695 2 15.5581 2H12.4419C11.5305 2 10.6686 2.41427 10.0993 3.12591L8.90073 4.62408C8.33142 5.33573 7.46948 5.75 6.55813 5.75H4.4C3.76348 5.75 3.15303 6.01339 2.70294 6.48223C2.25286 6.95107 2 7.58696 2 8.25V19.5C2 20.163 2.25286 20.7989 2.70294 21.2678C3.15303 21.7366 3.76348 22 4.4 22H23.6C24.2365 22 24.847 21.7366 25.2971 21.2678C25.7471 20.7989 26 20.163 26 19.5V8.25C26 7.58696 25.7471 6.95107 25.2971 6.48223C24.847 6.01339 24.2365 5.75 23.6 5.75H21.4419C20.5305 5.75 19.6686 5.33573 19.0993 4.62409L17.9007 3.12592Z",
    stroke: "#6E6E6E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17C15.9882 17 17.6 15.3211 17.6 13.25C17.6 11.1789 15.9882 9.5 14 9.5C12.0118 9.5 10.4 11.1789 10.4 13.25C10.4 15.3211 12.0118 17 14 17Z",
    stroke: "#6E6E6E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3dbe9d54d409c8f8c0af445b55459e9f.svg";
export { ForwardRef as ReactComponent };